/* Addon-Picker – Zusatzprodukte als Pseudo-Varianten.
 * Optional pro Gruppe: ein alternatives Produkt, das greift, wenn eine
 * bestimmte Variantenoption gewählt ist (z. B. "Top & Bottom").
 */
(function () {
  'use strict';
  if (window.__addonPicker) return;
  window.__addonPicker = true;

  var MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function formatMoney(cents, format) {
    var match = format.match(MONEY_PLACEHOLDER);
    var key = match && match[1];
    var precision = key && key.indexOf('no_decimals') !== -1 ? 0 : 2;
    var thousands = ',';
    var decimal = '.';

    if (key) {
      if (key.indexOf('comma_separator') !== -1) { thousands = '.'; decimal = ','; }
      else if (key.indexOf('apostrophe_separator') !== -1) { thousands = "'"; }
      else if (key.indexOf('space_separator') !== -1) { thousands = ' '; decimal = ','; }
    }

    var parts = (cents / 100).toFixed(precision).split('.');
    var value = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
    if (parts[1]) value += decimal + parts[1];
    return format.replace(MONEY_PLACEHOLDER, value);
  }

  function Picker(sectionId, config) {
    this.sectionId = sectionId;
    this.moneyFormat = config.moneyFormat || '${{amount}}';
    this.moneyWithCurrencyFormat = config.moneyWithCurrencyFormat || '${{amount}}';
    this.variants = config.variants || {};
    this.groups = [].slice.call(
      document.querySelectorAll('[data-addon-group][data-addon-section="' + sectionId + '"]')
    );
    this.busy = false;
    this.silent = false;
    this.root = this.groups.length
      ? this.groups[0].closest('.shopify-section') || document
      : document;
    if (this.groups.length) this.bind();
  }

  Picker.prototype.bind = function () {
    var self = this;

    this.groups.forEach(function (group) {
      group.addEventListener('change', function (event) {
        if (!event.target.matches('[data-addon-option]')) return;
        self.render();
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        requestAnimationFrame(self.update.bind(self));
      });
      if (PUB_SUB_EVENTS.optionValueSelectionChange) {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
          requestAnimationFrame(self.update.bind(self));
        });
      }
    } else {
      this.observe();
    }

    this.update();
  };

  Picker.prototype.observe = function () {
    var self = this;
    var price = this.priceEl();
    if (!price || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (self.silent) return;
      self.update();
    }).observe(price, { childList: true, subtree: true, characterData: true });
  };

  /* ---------- aktuelle Variante ---------- */

  Picker.prototype.form = function () {
    return (
      this.root.querySelector('#product-form-' + this.sectionId) ||
      this.root.querySelector('form[action*="/cart/add"]')
    );
  };

  Picker.prototype.currentId = function () {
    var form = this.form();
    var input = form && form.querySelector('input[name="id"]');
    return input && input.value;
  };

  Picker.prototype.currentOptions = function () {
    var variant = this.variants[this.currentId()];
    return variant ? variant[2] : [];
  };

  /* Passende Addon-Variante zur aktuell gewaehlten Hauptvariante finden.
     Trifft kein Variantentitel zu, greift die hinterlegte Standardvariante. */
  Picker.prototype.resolve = function (input) {
    var fallback = input.dataset.variantId
      ? { id: Number(input.dataset.variantId), price: +input.dataset.price || 0 }
      : null;

    var raw = input.dataset.addonVariants;
    if (!raw) return fallback;

    var options = this.currentOptions().map(function (value) {
      return value.trim().toLowerCase();
    });
    if (!options.length) return fallback;

    var entries = raw.split('~~');
    for (var i = 0; i < entries.length; i++) {
      var parts = entries[i].split('::');
      if (parts.length < 3) continue;
      if (options.indexOf(parts[0].trim().toLowerCase()) !== -1) {
        return { id: Number(parts[1]), price: +parts[2] || 0 };
      }
    }
    return fallback;
  };

  /* ---------- Auswahl ---------- */

  Picker.prototype.selected = function () {
    var self = this;
    var out = [];
    this.groups.forEach(function (group) {
      var active = group.querySelector('[data-addon-option]:checked');
      if (!active) return;
      var resolved = self.resolve(active);
      if (resolved) out.push(resolved);
    });
    return out;
  };

  Picker.prototype.surcharge = function () {
    return this.selected().reduce(function (sum, item) { return sum + item.price; }, 0);
  };

  /* ---------- Anzeige ---------- */

  Picker.prototype.priceEl = function () {
    return (
      this.root.querySelector('#price-' + this.sectionId) ||
      this.root.querySelector('.price')
    );
  };

  /* {price} in den Button-Texten durch den aktuellen Variantenpreis ersetzen */
  Picker.prototype.syncLabels = function () {
    var self = this;
    this.groups.forEach(function (group) {
      group.querySelectorAll('[data-addon-option]').forEach(function (input) {
        var span = document.querySelector('label[for="' + input.id + '"] [data-addon-label]');
        if (!span) return;
        var template = span.dataset.template || '';
        if (template.indexOf('{price}') === -1) return;

        var resolved = self.resolve(input);
        var text = template.replace(
          /\{price\}/g,
          resolved ? formatMoney(resolved.price, self.moneyFormat) : ''
        );
        if (span.textContent !== text) span.textContent = text;
      });
    });
  };

  Picker.prototype.update = function () {
    this.syncLabels();
    this.render();
  };

  Picker.prototype.render = function () {
    var el = this.priceEl();
    if (!el) return;

    var variant = this.variants[this.currentId()];
    if (!variant) return;

    var extra = this.surcharge();
    var format = /[A-Za-z]{3}\s*$/.test(el.textContent)
      ? this.moneyWithCurrencyFormat
      : this.moneyFormat;

    this.silent = true;

    var total = formatMoney(variant[0] + extra, format);
    var regular = el.querySelector('.price__regular .price-item--regular');
    var sale = el.querySelector('.price__sale .price-item--sale');
    var struck = el.querySelector('.price__sale s.price-item--regular');

    if (regular) regular.textContent = total;
    if (sale) sale.textContent = total;
    if (struck && variant[1]) struck.textContent = formatMoney(variant[1] + extra, format);

    var self = this;
    setTimeout(function () { self.silent = false; }, 0);
  };

  /* ---------- Warenkorb ---------- */

  Picker.prototype.submit = function (form) {
    var self = this;
    var data = new FormData(form);
    var quantity = parseInt(data.get('quantity'), 10) || 1;
    var mainId = data.get('id');
    var properties = {};

    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    });

    var items = [{ id: Number(mainId), quantity: quantity }];
    if (Object.keys(properties).length) items[0].properties = properties;

    this.selected().forEach(function (addon) {
      items.push({ id: addon.id, quantity: quantity, properties: { _addon_for: String(mainId) } });
    });

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    this.loading(form, true);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (result) {
        if (result.status) return self.error(form, result.description || result.message);
        self.error(form, null);
        if (cart && cart.renderContents) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
          if (cart.open) cart.open();
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        self.busy = false;
        self.loading(form, false);
      });
  };

  Picker.prototype.loading = function (form, state) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;
    button.classList.toggle('loading', state);
    button.setAttribute('aria-disabled', state ? 'true' : 'false');
    var spinner = form.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !state);
  };

  Picker.prototype.error = function (form, message) {
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    var target = form.querySelector('.product-form__error-message');
    if (!wrapper || !target) return;
    if (message) {
      target.textContent = message;
      wrapper.removeAttribute('hidden');
    } else {
      wrapper.setAttribute('hidden', '');
    }
  };

  /* ---------- Registry ---------- */

  var pickers = {};

  function parseConfig(node) {
    var variants = {};
    (node.dataset.variants || '').split('|').forEach(function (entry) {
      var parts = entry.trim().split(':');
      if (parts.length < 3) return;
      variants[parts[0]] = [
        +parts[1],
        +parts[2],
        parts[3] ? parts[3].split('~') : []
      ];
    });
    return {
      moneyFormat: node.dataset.moneyFormat,
      moneyWithCurrencyFormat: node.dataset.moneyCurrencyFormat,
      variants: variants
    };
  }

  function boot() {
    document.querySelectorAll('[data-addon-config]').forEach(function (node) {
      var id = node.id.replace('addon-config-', '');
      if (pickers[id]) return;
      pickers[id] = new Picker(id, parseConfig(node));
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form.tagName !== 'FORM') return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;

      var picker = null;
      for (var key in pickers) {
        if (pickers[key].root !== document && pickers[key].root.contains(form)) {
          picker = pickers[key];
          break;
        }
      }
      if (!picker || !picker.selected().length) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (picker.busy) return;
      picker.busy = true;
      picker.submit(form);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    pickers = {};
    boot();
  });
})();